<template >
  <div class="page-content">
    <div class="con" v-html="$props.content"></div>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.page-content {
  display: flex;
  .con {
    ::v-deep p {
      font-size: 18px;
      font-size: var(--font-size-18);
      font-weight: 500;
      line-height: 44px;
      color: #303133;
      text-indent: 2em;
    }
  }
}
</style>
